import Section, { SectionVisibilityProps } from './Section';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import useAppMethods from '../../../hooks/utility/useAppMethods';
import { SectionType } from './CheckoutInfoBag';
import { Checkbox } from '../../ui/checkbox';

export default function RememberMeSection({ show }: SectionVisibilityProps) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Checkout:Sections:RememberMeSection' });

  const { toggleLoginModal } = useAppMethods();

  const [checked, setChecked] = useState(false);

  const onClick = () => {
    setChecked(true);

    toggleLoginModal({
      openModal: true,
      onCloseRedirect: () => setChecked(false),
    });
  };

  return (
    <Section hideDivider show={show} id={SectionType.remember_me} className="!py-none px-md" containerClassName="pb-md">
      <div className="flex w-full items-start gap-sm p-md border-xs rounded-lg bg-brand-card border-mobile-secondary cursor-pointer">
        <Checkbox checked={checked} onCheckedChange={onClick} id="remember-me" className="mt-[6px]" />
        <div className="cursor-pointer">
          <label htmlFor="remember-me" className="my-auto flex flex-col gap-1 cursor-pointer">
            <div className="flex items-center gap-2">
              <h6 className="text-sm">{t('title')}</h6>
            </div>
            <p className="text-sm text-brand-text-secondary">{t('form.remember_me.label')}</p>
          </label>
        </div>
      </div>
    </Section>
  );
}
